import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './shared-outfit-upload-placeholder.scss';

applyTranslations(require('./shared-outfit-upload-placeholder.i18n.json'));

type Props = {
  imageUrl: string | undefined | null
};

const SharedOutfitUploadPlaceholder = (
  {
    imageUrl
  }: Props
): JSX.Element => (
  <section className="shared-outfit-upload-placeholder">
    {imageUrl && (
      <img
        src={imageUrl}
        alt="Outfit"
        className="shared-outfit-upload-placeholder__image"
      />
    )}
    {!imageUrl && (
      <div className="shared-outfit-upload-placeholder__container">
        <SVGDynamicIcon
          name="plus-inside-circle-custom-bg"
          width={25}
          height={25}
          customColor="grey-light"
        />
        <div className="shared-outfit-upload-placeholder__text">
          {__t('shared_outfit_upload_placeholder.label')}
        </div>
      </div>
    )}
  </section>
);

export default SharedOutfitUploadPlaceholder;
